import { useEffect, useState } from 'react'

import { addWeeks, startOfDay, startOfWeek, startOfYear } from '@util/date-util'

import { StyledAlert } from '../../theme/components/StyledAlert'

type Props = {
  jaar: Date | null
  week: number | undefined
}

const MINIMUM_WEEKS_START_UITVOERING_FROM_TODAY = 15

export const StartUitvoeringWarning = ({ jaar, week }: Props) => {
  const [displayWeekWarning, setDisplayWeekWarning] = useState(false)

  useEffect(() => {
    if (!jaar || !week) {
      setDisplayWeekWarning(false)
      return
    }

    const today = startOfDay(new Date())
    const fifteenWeeksFromNow = startOfWeek(
      addWeeks(today, MINIMUM_WEEKS_START_UITVOERING_FROM_TODAY),
    )

    const year = startOfYear(jaar)
    const uitvoeringsweek = startOfWeek(addWeeks(year, week))

    setDisplayWeekWarning(uitvoeringsweek < fifteenWeeksFromNow)
  }, [jaar, week])

  if (!displayWeekWarning) {
    return null
  }

  return (
    <StyledAlert severity="warning" title="Let op!">
      De geselecteerde datum van start uitvoering is niet ver in de toekomst.
      Dit zorgt voor een korte voorbereidingstijd.
    </StyledAlert>
  )
}
